import { atom } from 'recoil';

export const amplitudeEventQueueState = atom<
  { name: string; params?: Record<string, any> }[]
>({
  default: [],
  key: 'amplitudeEventQueueState',
});

export const amplitudeUserIdSetState = atom<boolean>({
  default: false,
  key: 'amplitudeUserIdSetState',
});

export const hubspotConversationsInitializedState = atom<boolean>({
  default: false,
  key: 'hubspotConversationsInitializedState',
});

export const showHubspotChatBubbleState = atom<boolean>({
  default: false,
  key: 'showHubspotChatBubbleState',
});
